module.exports = __webpack_public_path__ + "static/media/Niveau_elN4_3_381311.cbc4c3b7.png";